import React, { FC, useContext } from "react";
import { MainCover5Props, MainCover5Type } from "../../main-cover.types";
import styles from "./main-cover-5.module.css";
import { useDataSlider } from "../../main-cover-hook";
import {
  handleClickScroll,
  useAnalytics,
  useAppNavigate } from
"@commons-monorepo/index";
import { MAIN_COVER_EVENTS } from "../../main-cover-events";
import { UiButton } from "@ui-monorepo/index";
import WidgetContainer from "../../../widget-container";
import { ContentCoverContext } from "../../main-cover.context";

const MainCover5: FC<MainCover5Props> = ({ classType }) => {
  const { config, theme, storeMetadata, isMobile } =
  useContext(ContentCoverContext);
  const [logEvent] = useAnalytics({ storeMetadata });
  const {
    enabled,
    enabled_button,
    text,
    text_button,
    position,
    slider_arrow_enabled
  } = config.welcome;
  const { getCoverPreview } = useDataSlider();
  const navigate = useAppNavigate();
  const cover = config.welcome.image;

  const scrollDown = () => {
    logEvent(MAIN_COVER_EVENTS.SELECT_WEB_BANNER_ARROW);
    handleClickScroll("scroll-to-element");
  };

  const handleAction = () => {
    logEvent(MAIN_COVER_EVENTS.SELECT_WEB_BUY_NOW_BANNER);
    scrollDown();
    navigate("todos-los-productos", { relative: "path" });
  };

  const copy = () => `${text}`;
  const copyBtn = () => `${text_button}`;

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      fullWidth={classType === MainCover5Type.full}
      withoutPadding>

      <div
        className={`${styles.mainCover5Container} ${styles[classType]} ${styles.wrapperMainCover5}`}
        aria-label='wrapper-cover'>

        {cover.cover_image && isMobile &&
        <div
          className={`${styles.imageBg} ${styles.coverImg}`}
          style={{
            backgroundImage: `url(${getCoverPreview(cover.cover_image)})`
          }}>
        </div>}

        {cover.web_cover && !isMobile &&
        <div
          className={`${styles.imageBg} ${styles.coverImg}`}
          style={{ backgroundImage: `url(${cover.web_cover})` }}>
        </div>}

        <div className={`${styles[position]} ${styles.portraitActions}`}>
          {enabled && <p className={styles.welcomeText}>{copy()}</p>}
          {enabled_button &&
          <UiButton isFilled theme={theme} onClick={handleAction}>
              {copyBtn()}
            </UiButton>}

        </div>
        {slider_arrow_enabled &&
        <i
          onClick={scrollDown}
          className={`icon-arrow ${styles.icon}`}
          data-testid='icon-down' />}


      </div>
    </WidgetContainer>);

};

export default MainCover5;